import { jwtDecode } from "jwt-decode"

export const getCookie = (name: string): string | undefined => {
  const value = `; ${document.cookie}`
  const parts = value.split(`; ${name}=`)

  if (parts && parts.length === 2) return parts.pop()?.split(";").shift()
}

// The browser sends this cookie with private file requests (<img>, links),
// which cannot carry the Authorization header. Only /assets/private reads it.
const FILES_TOKEN_COOKIE = "filesToken"

// On babele hosts the cookie must reach the API, a sibling subdomain.
// Anywhere else (a custom domain) it stays on that host and reaches the API
// through the /assets/private proxy.
export const isBabeleHost = () =>
  window.location.hostname.endsWith(".babele.co")

const filesTokenAttributes = (expires: Date) => {
  const domain = isBabeleHost() ? "; domain=.babele.co" : ""
  return `expires=${expires.toUTCString()}; path=/assets/private${domain}; Secure; SameSite=Lax`
}

export const setFilesTokenCookie = (token: string, expires: Date): void => {
  document.cookie = `${FILES_TOKEN_COOKIE}=${token}; ${filesTokenAttributes(expires)}`
}

export const clearFilesTokenCookie = (): void => {
  document.cookie = `${FILES_TOKEN_COOKIE}=; ${filesTokenAttributes(new Date(0))}`
}

// Mirrors the auth token into the cookie, expiring with the token itself.
export const syncFilesTokenCookie = (token: string | undefined): void => {
  try {
    const exp = token ? jwtDecode(token).exp : undefined
    if (token && exp) {
      setFilesTokenCookie(token, new Date(exp * 1000))
      return
    }
  } catch {
    // Not a JWT: nothing the API would accept, so clear instead.
  }
  clearFilesTokenCookie()
}
